import {
  AdminSpecialCalculationCostDetailTemplate,
  LoadingTemplate,
  SiteAdminNotFoundTemplate,
} from '@/components/templates';
import { useSpecialCalculationCostDetail } from '@/hooks/admin';
import { useParams } from 'react-router-dom';

const SiteAdminSpecialCalculationCostDetailPage = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';
  const recordId = Number(id) || 0;

  const { data, status } = useSpecialCalculationCostDetail(recordId);

  const breadcrumbItems = [
    {
      title: '特殊医療助成金',
      href: `/${currentSite}/admin/special_calculation_costs`,
    },
    { title: ':id' },
  ];

  if (status === 'pending') return <LoadingTemplate />;
  if (status === 'error' || !data) return <SiteAdminNotFoundTemplate />;

  return (
    <main>
      <AdminSpecialCalculationCostDetailTemplate breadcrumbItems={breadcrumbItems} data={data} />
    </main>
  );
};

export default SiteAdminSpecialCalculationCostDetailPage;
